<template lang="pug">
  div(v-loading='!isLoading' loading-spinner='circular')
    menu-dropdown
    section.cards
      loyalty-card(v-for="(item, index) in this.listCards" :key="index" :title="item.title" :body="item.body" :namePath="item.name")
</template>
<script>
import LoyaltyDropDown from '@/components/loyalty/LoyaltyDropDown'
import LoyaltyCard from '@/components/loyalty/LoyaltyCard'
import i18n from '@/lang/i18n.js'
import { mapGetters } from 'vuex'

export default {
  name: 'Loyalty',
  data: () => {
    return {
      listCards: [
        {
          title: i18n.t('breadcrumb.programs'),
          body: i18n.t('loyalty.programsDescription'),
          name: 'LoyaltyPrograms'
        },
        {
          title: i18n.t('breadcrumb.accounts'),
          body: i18n.t('loyalty.accountsDescription'),
          name: 'LoyaltyAccounts'
        },
        {
          title: i18n.t('breadcrumb.coupons'),
          body: i18n.t('loyalty.couponsDescription'),
          name: 'LoyaltyCoupons'
        },
        /*
        {
          title: i18n.t('breadcrumb.marketing'),
          body: i18n.t('loyalty.marketingDescription'),
          name: ''
        },
        */
        {
          title: i18n.t('breadcrumb.Analytics'),
          body: i18n.t('loyalty.AnalyticsDescription'),
          name: 'LoyaltyAnalytics'
        }
      ]
    }
  },
  components: {
    'menu-dropdown': LoyaltyDropDown,
    'loyalty-card': LoyaltyCard
  },
  computed: {
    ...mapGetters({
      isLoading: 'getDropMenuState',
      getLang: 'getLang'
    })
  },
  destroyed () {
    // Init range time for analytics
    sessionStorage.removeItem('loyaltyAnalyticsDateTo')
  },
  watch: {
    getLang (data, oldData) {
      const dataCards = [
        {
          title: i18n.t('breadcrumb.programs'),
          body: i18n.t('loyalty.programsDescription'),
          name: 'LoyaltyPrograms'
        },
        {
          title: i18n.t('breadcrumb.accounts'),
          body: i18n.t('loyalty.accountsDescription'),
          name: 'LoyaltyAccounts'
        },
        {
          title: i18n.t('breadcrumb.coupons'),
          body: i18n.t('loyalty.couponsDescription'),
          name: 'LoyaltyCoupons'
        },
        /*
        {
          title: i18n.t('breadcrumb.marketing'),
          body: i18n.t('loyalty.marketingDescription'),
          name: ''
        },
        */
        {
          title: i18n.t('breadcrumb.Analytics'),
          body: i18n.t('loyalty.AnalyticsDescription'),
          name: 'LoyaltyAnalytics'
        }
      ]
      this.listCards = dataCards
    }
  }
}
</script>
<style lang="scss">
.cards{
  padding: rem(45) rem(95);
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
   @media only screen and (max-width: 500px) {
    padding: rem(25) rem(50) !important;
  }
   @media only screen and (max-width: 380px) {
    padding: rem(25) rem(10) !important;
  }
}
.actionsCupons {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.actionsLeft {
  display: flex;
  gap: -10px;
  justify-content: flex-start;
  align-items: center;
  font-weight: 500;
}
.glue {
  margin-left: -24px;
}
.actionsRight {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  align-items: center;
}
.kpidataCoupon{
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fill,100px);
  grid-template-columns: repeat(auto-fit,100px);
  grid-template-columns: repeat(auto-fit,minmax(200px, 1fr));
  @media only screen and (max-width: 500) {
    padding: rem(25) rem(50) !important;
  }
  @media only screen and (max-width: 380) {
    padding: rem(25) rem(10) !important;
  }
}
.activeC {
  padding: rem(18) rem(18) rem(18) rem(17);
  height: 8.75rem;
  flex: auto;
  border-left: none !important;
  border-right: none !important;
  border-top: none !important;
  border-bottom-color: #1168A6;
  border-bottom-width: 2px;
  background-color: rgba(227, 235, 241, .4) !important;
  cursor: pointer;
}
.kpi-cardsC {
  padding: rem(18) rem(18) rem(18) rem(17);
  height: 8.75rem;
  opacity: 50;
  flex: auto;
  border: 1px solid #D7DADC;
  background-color: #FFFFFF;
  cursor: pointer;

  &__title{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  &__conteo{
    font-family: Soho;
    font-size: 30px;
    line-height: 48px;
    letter-spacing: 0px;
    text-align: left;
    font-weight: 500;
    color: #333;
    text-transform: uppercase;
  }
  &__conteotext{
    text-align: left;
  }
  &__square-title-text{
    text-transform: initial;
    color: #6E767D;
  }
  &__square-text{
    display: flex;
    width: 75%;
    text-transform: initial;
    text-align: left;
    color: #6E767D;
    margin-left: 5px;
  }
  &__square-content{
    width: 100%;
    height: 100%;
    border-radius: 2px;
  }
  &__square{
    width: 16px;
    height: 16px;
  }
}
.barformat {
  margin-top:23px;
}
</style>
